import React from 'react';
import ListItem from './ListItem.js';

export default function ListView({ setBatch, batchList, curUser }) {
  let renderedList = [];

  for (const [key, value] of Object.entries(batchList)) {
    for (const [key, value] of Object.entries(value)) {
      renderedList.push(value);
    }
  }

  const list = renderedList.map((item) => {
    return <ListItem key={item.batch_id} item={item} editUTMs={setBatch} />;
  });

  return (
    <div className="container u--margin-top-35">
      <CreateUTMButton createBatch={setBatch} curUser={curUser} />
      <ListHeaders />
      {list}
    </div>
  );
}

function CreateUTMButton({ createBatch, curUser }) {
  const newBatch = {
    batch_id: '',
    user: curUser,
    organization: 'User Org',
    groupName: '',
    utm_codes: []
  };

  return (
    <div className="grid">
      <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <p>
          <button
            className="btn btn--blue"
            onClick={() => createBatch(newBatch)}
          >
            <span className="btn__content">
              <span className="btn__text">Create New UTM</span>
            </span>
          </button>
        </p>
      </div>
    </div>
  );
}

function ListHeaders() {
  return (
    <div className="u--margin-auto">
      <div className="grid utm__list-headers">
        <div className="grid__col-lg-3">Date</div>
        <div className="grid__col-lg-2">User</div>
        <div className="grid__col-lg-1">Org</div>
        <div className="grid__col-lg-3">Group Name</div>
        <div className="grid__col-lg-1">#UTMs</div>
        <div className="grid__col-lg-2">Actions</div>
      </div>
    </div>
  );
}
